<template>
  <el-container class="view-content">
    <el-header class="header-content">
      <el-row type="flex" justify="space-between" align="middle">
        <statistics :count-list="countList"/>
        <el-button-group>
          <el-button size="small" type="primary" @click="sendAll">广播发送</el-button>
          <el-button size="small" type="primary" @click="add">添加域名</el-button>
        </el-button-group>
      </el-row>
    </el-header>
    <el-main class="main-content">
      <vue-table :table-data="tableData">
        <template slot="actionBar">
          <el-table-column align="center" label="操作栏" :resizable="false" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="revise(scope.row)">修改</el-button>
              <el-button type="text" class="danger" @click="remove(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </template>
      </vue-table>
    </el-main>
    <el-footer class="footer-content">
      <vue-pagination :paging-data="pagingData" @table-reload="getTableList" ref="paging"></vue-pagination>
    </el-footer>
    <domain-operate v-if="domainOperate.visible" :dialog-data="domainOperate" @table-reload="getTableList"/>
  </el-container>
</template>

<script>
  import {PagingData} from "@mixins"
  import DomainOperate from "./dialog/DomainOperate"
  export default {
    name: "BlackList",
    mixins: [PagingData],
    components: {DomainOperate},
    data() {
      return {
        // 统计
        countList: [
          {name: "总记录", count: 0},
        ],
        // 表格数据
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "域名（IP地址）", property: "name"},
            {label: "备注", property: "remark"},
            {label: "创建时间", property: "create_at"},
          ],
        },
        domainOperate: {visible: false, width: 450, title: "", row: null, type: "Black"},
      }
    },
    methods: {
      sendAll() {
        this.openConfirm("给所有设备下发白名单域名", async () => {
          let res = await this.$Http.domainBroadcast();
          if (res) {
            this.msgSuccess("操作成功");
          }
        });
      },
      add() {
        this.domainOperate.visible = true;
        this.domainOperate.title = "添加域名";
        this.domainOperate.row = null;
      },
      revise(row) {
        this.domainOperate.visible = true;
        this.domainOperate.title = "修改域名";
        this.domainOperate.row = row;
      },
      remove(row) {
        this.openConfirm("删除该域名", async ()=> {
          let nv = {optionId: row.id};
          let res = await this.$Http.deleteDomain(nv);
          if (res) {
            this.msgSuccess("删除成功");
            this.$refs["paging"].removeFinish(1);
            this.getTableList();
          }
        });
      },
      //获取表格数据
      async getTableList() {
        let nv = {
          page: this.pagingData.currentPage,
          limit: this.pagingData.pageSize,
        };
        let res = await this.$Http.getDomain(nv);
        if (res?.data) {
          let total = +res.data.total || 0;
          this.pagingData.total = total;
          this.countList[0].count = total;
          this.tableData.tableList = this.getArray(res.data.list);
        }
      },
    },
    created() {
      this.getTableList();
    }
  }
</script>

<style scoped>

</style>
